import './mutators/smartPillBlockMutators';
import './mutators/updateItemLanguageMutator';

export { default as MailSmartPillBlock } from './components/MailSmartPillBlock';
